import script from "./AdminHtmlPages.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHtmlPages.vue?vue&type=script&setup=true&lang=js"

import "./AdminHtmlPages.vue?vue&type=style&index=0&id=b2028320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2028320"]])

export default __exports__